import React, { useContext, useRef } from "react";
import { Button } from "antd";
import "./instructionFooter.scss";
import LoaderContext from "../../../Context/LoaderContext/Index";

interface InstructionFooterProps {
  handleFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const InstructionFooter: React.FC<InstructionFooterProps> = ({ handleFileChange }) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const { isLoading } = useContext(LoaderContext);

  const handleFileUpload = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <div className="instructions_footer">
      <Button type="primary" onClick={handleFileUpload} loading={isLoading}>
        Upload Resume
      </Button>
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        accept=".pdf, .doc, .docx"
        onChange={handleFileChange}
      />
    </div>
  );
};

export default InstructionFooter;
